<template><div><h1>Can’t resolve ‘…/inline-desc’ in</h1>
<p>webpack resolve 配置</p>
<pre class="hljs"><code>resolve: {
  <span class="hljs-attr">extensions</span>: [<span class="hljs-string">''</span>, <span class="hljs-string">'.js'</span>, <span class="hljs-string">'.vue'</span>, <span class="hljs-string">'.json'</span>]
}
</code></pre>
</div></template><script>
export default {
  head: {"title":"Can't resolve '../inline-desc' in | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// cannot-resolve-inline-desc-41.vue?cc532896